import { render, staticRenderFns } from "./RichiediServizioChat.vue?vue&type=template&id=67773b00"
import script from "./RichiediServizioChat.vue?vue&type=script&lang=js"
export * from "./RichiediServizioChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports